// Campaign goal types for AI strategist
export type CampaignGoalType = "sales" | "recruiting" | "branding" | "events";

// Target acquisition modes for guest onboarding
export type TargetAcquisitionMode = "automatic" | "csv" | "sales_nav";

// Uploaded target structure (from CSV or Sales Nav)
export interface UploadedTarget {
  linkedin_url: string;
  profile_url: string;
  first_name?: string | null;
  last_name?: string | null;
  company?: string | null;
  title?: string | null;
  provider_id?: string | null;
  sales_nav_url?: string | null;
  custom_data?: any;
  name?: string | null;
  link_type?: string;
}

// Business DNA collected by AI strategist
export interface BusinessDNA {
  productService?: string;      // "What are you selling?"
  expensiveProblem?: string;    // "What problem does it solve?"
  dealSize?: string;            // "Average deal size?"
  bestCustomers?: string;       // "Who are your best customers?"
  hiringTitle?: string;         // For recruiting: "What title are you hiring?"
  requiredSkills?: string;      // For recruiting: "Required skills?"
  topics?: string;              // For branding: "What topics?"
}

export interface ManagedCampaignData {
  // Campaign basics
  campaignName: string;
  /** True while the name was generated automatically (not typed by the user). */
  campaignNameAuto?: boolean;
  clientId: string;
  isPremium?: boolean;

  // NEW: AI Strategist fields (Phase 0 & 1)
  campaignGoal?: CampaignGoalType;
  businessDNA?: BusinessDNA;

  // Target acquisition mode (for guest onboarding)
  targetAcquisitionMode?: TargetAcquisitionMode;
  uploadedTargets?: UploadedTarget[];
  salesNavUrl?: string; // Sales Navigator search URL (for super admin to use)

  // Target audience (same as CSV requests)
  countries: string[];
  cities: string[];
  industries: string[];
  companySizes: string[];
  companyKeywords: string[];
  personKeywords: string[];
  excludeCompanyKeywords?: string[];
  excludePersonKeywords?: string[];
  departments: string[];
  jobTitles: string[];
  seniorityLevels: string[];
  additionalNotes: string;

  // Sequence template
  sequences: SequenceStep[];

  // Campaign settings
  timezone: string;
  workingHoursStart: number;
  workingHoursEnd: number;
  workingDays: number[];
  maxConnectionsDaily: number;
  maxMessagesDaily: number;
}

export interface SequenceStep {
  step_number: number;
  action_type: "connect" | "message" | "end";
  delay_hours: number;
  message_template?: string;
  include_message?: boolean;
}

export const initialManagedCampaignData: ManagedCampaignData = {
  campaignName: "",
  clientId: "",
  isPremium: false,
  targetAcquisitionMode: "automatic",
  uploadedTargets: [],
  salesNavUrl: "",
  countries: [],
  cities: [],
  industries: [],
  companySizes: [],
  companyKeywords: [],
  personKeywords: [],
  excludeCompanyKeywords: [],
  excludePersonKeywords: [],
  departments: [],
  jobTitles: [],
  seniorityLevels: [],
  additionalNotes: "",
  sequences: [
    {
      step_number: 1,
      action_type: "connect",
      delay_hours: 0,
      include_message: false,
    },
    {
      step_number: 2,
      action_type: "end",
      delay_hours: 0,
    },
  ],
  timezone: "Asia/Kolkata",
  workingHoursStart: 9,
  workingHoursEnd: 18,
  workingDays: [1, 2, 3, 4, 5],
  maxConnectionsDaily: 20,
  maxMessagesDaily: 20,
};
